import Vue from 'vue'
import set from 'lodash/set'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = require
    .context('./locales/', true, /^\.\/.*\.js$/)
    .keys()
    .reduce((messages, file) => {
        const locale = file.replace('./', '').replace('.js', '')

        set(messages, locale.split('/'), require(`./locales/${locale}`).default)

        return messages
    }, [])

export const allowedLocales = messages.reduce((locales, locale) => locales.concat([locale]), [])

export default new VueI18n({
    locale: 'en',
    messages,
})
